// src/services/FeaturedProductServices.js
import api from "../api/api";

/**
 * Normalize backend response
 */
const normalizeProductsResponse = (response) => {
  if (!response?.data) return [];
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.data.data)) return response.data.data;
  return [];
};

export const FeaturedProductServices = {
  getFeaturedProducts: async (limit = 6) => {
    const res = await api.get("/get-products");
    const products = normalizeProductsResponse(res);

    return limit ? products.slice(0, limit) : products;
  },
};
